export default __webpack_public_path__ + "static/media/dungeon-exploration.7ae1e184.png";